// extracted by mini-css-extract-plugin
export default {"Sort":"Sort_Sort__ortIr","label":"Sort_label__NMgWM"};